import type { MomentHeaderData } from "../../moment/hooks/use-moment-header";

export type MomentPageSection = "details" | "review" | "analytics" | "poll_results" | "outbox";

export const getMomentPageSections = (
  header: MomentHeaderData,
  ceAdmin: boolean,
): MomentPageSection[] => [
  "details",
  "review",
  ...(header.status === "draft"
    ? []
    : [
        "analytics" as const,
        ...(header.poll_ids?.length ? (["poll_results"] as const) : []),
        ...(ceAdmin ? (["outbox"] as const) : []),
      ]),
];
